import { ApiClientImplementation } from 'infra/api-client/api-client'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import SurgicalPendencyService from 'presentation/contexts/services/surgical-pendency-service'
import { ApiRepository } from 'repository/api-repository'
import { SurgicalPendencyRepository } from 'repository/repositories/surgical-pendency/surgical-pendency-repository'
import { RemoteAnswerSurgicalPendency } from 'service/usecases/answer-surgical-pendency/remote-answer-surgical-pendency'
import { RemoteUploadSurgicalPendencyDocument } from 'service/usecases/upload-surgical-pendency-document/remote-upload-surgical-pendency-document'

export default function makeSurgicalPendencyService() {
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(new ApiClientImplementation())
  )

  const surgicalPendencyRepository = new SurgicalPendencyRepository(
    apiRepository
  )

  const answerSurgicalPendency = new RemoteAnswerSurgicalPendency(
    surgicalPendencyRepository
  )
  const uploadSurgicalPendencyDocument =
    new RemoteUploadSurgicalPendencyDocument(surgicalPendencyRepository)

  return new SurgicalPendencyService({
    answerSurgicalPendency,
    uploadSurgicalPendencyDocument
  })
}
